// extracted by mini-css-extract-plugin
export default {"imageWrapper":"xL-z","twoColumnImage":"yL-z"};